import Helpers from "./helpers";
import Logger from "./Logger";

declare var LC_API: any;

export default class LiveChatOpen {

	constructor() {

		this.attachEvents();
	}

	private attachEvents() {

		const triggerButtons = document.querySelectorAll('.js-live-chat-open');
		const chatFacade = document.querySelector('.js-live-chat-facade') as HTMLButtonElement;

		Helpers.scopedLoop(triggerButtons, (item, i, context) => {

			item.addEventListener('click', () => {

				try {
					if (chatFacade) {
						chatFacade.click();
						setTimeout(() => {
							if (typeof LC_API === "undefined") {
								this.showErrorMessage(item);
							}
						}, 5000);
					} else {
						LC_API.open_chat_window();
					}
				} catch (error) {
					Logger.trackException(error);
					this.showErrorMessage(item);
				}

			});

		}, this);

	}

	private showErrorMessage(item: HTMLElement) {
		const liveChatMessage = item.closest('.js-live-chat-container').querySelector('.js-live-chat-message');
		liveChatMessage.setAttribute('aria-hidden', 'false');
		liveChatMessage.setAttribute('role', 'alert');
	}

}
